var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable react/display-name,complexity */
import React, { forwardRef, useState, isValidElement, cloneElement, useEffect } from 'react';
import cx from 'classnames';
import { Swipeable } from 'react-swipeable';
import { Button, Container } from '../';
import StepperItem from '../StepperItem/StepperItem';
import * as S from './styles';
var swipeConfig = {
    delta: 100,
    preventDefaultTouchmoveEvent: false,
    trackTouch: true,
    trackMouse: true
};
var INACTIVE_SCALE_COEFFICIENT = 0.84;
export var Stepper = forwardRef(function Stepper(_a, ref) {
    var children = _a.children, activeIndex = _a.activeIndex, accentedActiveItem = _a.accentedActiveItem, noPadding = _a.noPadding, onChangeHandler = _a.onChangeHandler, showButtons = _a.showButtons, adaptive = _a.adaptive, isSwipeable = _a.isSwipeable, isSwipeLeftBlocked = _a.isSwipeLeftBlocked, isSwipeRightBlocked = _a.isSwipeRightBlocked, className = _a.className, style = _a.style;
    var _b = useState(0), active = _b[0], setActive = _b[1];
    useEffect(function () {
        if (activeIndex !== undefined)
            setActive(activeIndex);
    }, [activeIndex]);
    var noButtonsClassName = !showButtons ? "no-buttons" : false;
    var noPaddingClassName = adaptive ? "no-padding" : false;
    var adaptiveClassName = adaptive ? "adaptive" : false;
    var activeClassName = "active-" + active;
    var wrapperClass = cx(noButtonsClassName, adaptiveClassName, noPaddingClassName);
    var rootClass = cx(activeClassName, adaptiveClassName, noPaddingClassName, className);
    var changeActiveIndex = function (index) {
        setActive(index);
        if (onChangeHandler)
            onChangeHandler(index);
    };
    var onSwipedHandler = function (_a) {
        var dir = _a.dir;
        if (!Array.isArray(children) || !isSwipeable)
            return;
        if (dir === 'Left' && !isSwipeLeftBlocked && active + 1 < children.length)
            changeActiveIndex(active + 1);
        if (dir === 'Right' && !isSwipeRightBlocked && active > 0)
            changeActiveIndex(active - 1);
    };
    var items = Array.isArray(children) ? children : [children];
    return (React.createElement(S.Wrapper, { flex: true, direction: 'column', className: wrapperClass, style: style },
        React.createElement(Swipeable, __assign({ onSwiped: onSwipedHandler }, swipeConfig, { style: adaptive ? { display: 'flex', flexDirection: 'column' } : {} }),
            React.createElement(S.Stepper, { flex: true, alignItems: 'center', ref: ref, className: rootClass }, items.map(function (child, index) {
                if (isValidElement(child)) {
                    var isActive = active === index;
                    var scaleCompensationOffset = accentedActiveItem
                        ? ((1 - INACTIVE_SCALE_COEFFICIENT) / 2) * (active - index)
                        : 0;
                    var offset = (scaleCompensationOffset - active) * 100;
                    var translateStyle = "translate(" + offset + "%, 0)";
                    var scaleStyle = accentedActiveItem && !isActive ? "scale(" + INACTIVE_SCALE_COEFFICIENT + ")" : '';
                    var childProps = {
                        key: index,
                        style: {
                            transform: translateStyle + " " + scaleStyle,
                            opacity: accentedActiveItem && !isActive ? 0.5 : 1
                        },
                        onClick: isSwipeable || isActive ? undefined : function () { return changeActiveIndex(index); },
                        noPadding: noPadding
                    };
                    return cloneElement(child, childProps);
                }
            }))),
        showButtons && (React.createElement(Container, { flex: true, justifyContent: 'center', bottom: 'small' }, items.map(function (child, index) { return (React.createElement(Container, { padded: 'xsmall', key: index },
            React.createElement(Button, { fullWidth: false, size: 'xxsmall', variant: active === index ? 'primary' : 'outlined', circular: true, onClick: function () { return changeActiveIndex(index); } }))); })))));
});
Stepper.defaultProps = {
    accentedActiveItem: true,
    showButtons: true,
    noPadding: false,
    isSwipeable: true,
    adaptive: false,
    isSwipeLeftBlocked: false,
    isSwipeRightBlocked: false
};
Stepper.Item = StepperItem;
Stepper.displayName = 'Stepper';
export default Stepper;
//# sourceMappingURL=Stepper.js.map